// External libraries
import React from 'react';

// Internal modules
import { CI, getContent, getLocale, useMountLogging } from '@/lib';
import {
  payLaterSubmitHandler,
  payLaterTermsCheckedHandler,
  // @ts-expect-error untyped import
} from '../handlers';
import { useStoreState } from '@/store';
// @ts-expect-error untyped import
import { LazyAddress } from '../Components';
import { Button } from '@/components/Button';
import { Section } from '../StyledComponents';
import { getPayLaterHeaderContent } from './utils';
import { CountryDropdown } from '@/components/Locale';
import { formInputHandlers } from '../formInputHandlers';
import { PayIn4Illustration } from './PayIn4Illustration';
import { useHandleFormFocus } from '../hooks/useHandleFormFocus';
import { LazyKYCFields } from '@/components/SignupFields/Components';
import { Email, PhoneNumber } from '@/components/ContactInformation';
// @ts-expect-error untyped import
import { LazyPasswordInput } from '../../SignupFields/PasswordInput';
import { SectionHeader } from '@/components/Headings';
import { LegalDisclosures } from '@/components/SignupFields/LegalDisclosures';
import { LazyResidentialAddressInterstitial } from '@/components/Interstitials/ResidentialAddress/LazyResidentialAddress';
import { CountryCodes } from '@/generated/graphql';
import { HeadingText } from './StyledComponents';
import {
  atomicsDomain,
  atomicsFlows,
  atomicsTasks,
  atomicsViewNames,
} from '@/lib/atomics';

export const PayLaterForm = (): JSX.Element => {
  const { country } = getLocale();
  CI.endWith(CI.Event.PAY_LATER_RENDER, CI.Status.Ok);

  useMountLogging('PayLaterForm');

  const onFocus = useHandleFormFocus();
  const hasBNPLAltText = country === CountryCodes.Us;
  const isResidentialAddressOpen = useStoreState(
    ({ ui }) => ui.isResidentialAddressOpen,
  );
  return (
    <>
      <SectionHeader {...getPayLaterHeaderContent(hasBNPLAltText)} />
      {!hasBNPLAltText && <PayIn4Illustration />}
      <HeadingText level={3}>
        {getContent('sectionHeaders.accountInfo.signup.base')}
      </HeadingText>
      <form
        method="post"
        noValidate
        onSubmit={e => {
          CI.endWith(CI.Event.GUEST_XO_SIGNUP_FORM_USER_INPUT, CI.Status.Ok);
          payLaterSubmitHandler(e);
        }}
        onFocusCapture={onFocus}
      >
        <Section>
          <CountryDropdown />
          <LazyAddress
            {...formInputHandlers}
            showTitle={false}
            type="billing"
          />
          <LazyKYCFields {...formInputHandlers} />
          <PhoneNumber {...formInputHandlers} />
          <Email {...formInputHandlers} />
          <LazyPasswordInput {...formInputHandlers} />
          <LegalDisclosures
            {...formInputHandlers}
            changeHandler={payLaterTermsCheckedHandler}
          />
        </Section>
        <Button
          contentKey="buttons.signup.base"
          isFormSubmission
          testID="submit-button"
          atomicEventsAttributes={{
            domain: atomicsDomain,
            flow: atomicsFlows.guestAndSignup,
            intent: `click_${atomicsTasks.submitPayLater}`,
            task: atomicsTasks.selectAgreeAndCreateAccountContinuePayLater,
            viewName: atomicsViewNames.reviewYourPayment,
          }}
        >
          {getContent('buttons.signup.base')}
        </Button>
      </form>
      {isResidentialAddressOpen && (
        <LazyResidentialAddressInterstitial
          submitHandler={payLaterSubmitHandler}
        />
      )}
    </>
  );
};
